// extracted by mini-css-extract-plugin
module.exports = {"search_bar_form":"SearchBar_search_bar_form__1PN_3","search_btn":"SearchBar_search_btn__2MKVx"};